import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'

import { KVMessageDef } from './index'

export function getCameraPoseClickedMessage(): KVMessageDef {
  return {
    type: 'cameraPoseClicked',
    requiredData: ['imageName'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      // Find the photo with the matching filename and set it as selected
      const imageName = json.imageName as string
      const photo = kv.photos.find((p) => p.filename === imageName)

      // Only open the photo reel if a photo is found and either:
      // 1. It's different from the current selected photo, OR
      // 2. The photo reel is currently closed (allowing reopening with the same photo)
      if (photo && (kv.selectedPhoto?.id !== photo.id || !kv.photoReelOpen)) {
        kv.setPhotoReelOpen(true)
        kv.setSelectedPhoto(photo)
      }
    },
  }
}
